import { PlusIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { CreateReceiverDialog } from './CreateReceiverDialog';

import { CREATE_RECEIVER_TEST_ID } from '../constants';

type Props = {
  setKey: (key: number) => void;
};

export const CreateReceiverButton = ({ setKey }: Props) => {
  const [open, setOpen] = useState(false);

  const onClose = () => setOpen(false);

  return (
    <>
      <PrimaryButton
        onClick={() => {
          setOpen(true);
        }}
        data-testid={CREATE_RECEIVER_TEST_ID}
      >
        <PlusIcon className="size-4 stroke-current" />
        Create Receiver
      </PrimaryButton>
      {open && (
        <CreateReceiverDialog open={open} onClose={onClose} setKey={setKey} />
      )}
    </>
  );
};
